import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

export const StyledHeader = styled(FlexCenterY, {
  display: 'inline-flex',
  width: '100%',
})

export const StyledIcon = styled('img', () => ({
  width: '1.25rem',
  height: '1.25rem',
  marginRight: '.5rem',
}))

export const StyledTitle = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  margin: 0,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingXSmall,
  fontSize: '1rem',
}))

export const InfoBlockIconOverrides = {
  Svg: {
    style: () => ({
      flex: '0 0 2rem',
      marginRight: '.5rem',
    }),
  },
}
